 // variables
const loginModal = document.getElementById('members-login-modal')
const loginForm = document.getElementById('toggle-members-login')
const signupForm = document.getElementById('toggle-members-signup')
const memberTrigger = document.querySelector("#account-icon-open");
const membersModal = document.querySelector("account-modal");
const cartDrawer = document.querySelector("cart-drawer");
const recoverPasswordMsg = document.getElementById('recover-password-msg')
const loginErrors = document.getElementById('login-errors')
const registrationErrors = document.getElementById('registration-errors')

const setMode = (mode) => {
  const modes = ['mode-signup', 'mode-login', 'mode-welcome', 'mode-activate'];
  modes.forEach(mode => loginModal.classList.remove(mode));
  loginModal.classList.add(`mode-${mode}`);
}

const triggerDrawer = (mode) => {
  membersModal.open(memberTrigger);
  setMode(mode)
  if (cartDrawer.open){
    cartDrawer.close()
  }
}

const hashTriggers = () => {
  const url = new URL(location.href);
  if (url.hash === '#invalid-login'){
    triggerDrawer('login')
    loginErrors.innerText = "Incorrect email or password"
  } else if (url.hash === '#invalid-registration' || url.hash === '#signup'){
    triggerDrawer('signup')
    if (url.hash === '#invalid-registration'){
      registrationErrors.innerText = "Invalid email or password"
    }
  } else if (url.hash === '#activate-account'){
    const oneWeekInSeconds = 7 * 24 * 60 * 60;
    const baseURL = `${url.origin}${url.pathname}`;
    const welcomeURL = `${baseURL}#welcome`;
    document.cookie = `activation-referrer=${welcomeURL}; max-age=${oneWeekInSeconds}; path=/`;
    triggerDrawer('activate')
  } else if (url.hash === '#login'){
    triggerDrawer('login')
  } else if (url.hash === '#welcome'){
    document.cookie = "activation-referrer=; max-age=0; path=/";
    triggerDrawer('welcome')
  }
}

window.addEventListener("hashchange", () => {
  hashTriggers()
})

document.addEventListener('DOMContentLoaded', () => {
  // other triggerrs
  hashTriggers()
  
  if (recoverPasswordMsg && recoverPasswordMsg.textContent !== ''){
    triggerDrawer('login')
  }
})
  


